import { Injectable } from '@angular/core';
import { QuoteEngineCookie } from '@models/QuoteEngineCookie';

@Injectable({
	providedIn: 'root',
})
export class QuoteEngineCookieService {

	private readonly cookieKey: string = `QuoteEngineCookie`;
	private readonly domain: string = `.embracepetinsurance.com`;
	private readonly defaultValues: QuoteEngineCookie = {
		SessionId: ``,
		AddPet: false,
		ZipCode: ``,
		Email: ``,
		Brand: ``,
		PetIndex: 0,
		QuoteType: `New`,
		Direct: false,
		WellnessOnly: false,
		TrialPlanInitial: false,
		TrialPlanContinuation: false,
		Purchased: false,
	};

	private get maxAge(): number {
		const days: number = 30;
		const hoursInDay: number = 24;
		const minutesInHour: number = 60;
		const secondsInMinute: number = 60;

		return days * hoursInDay * minutesInHour * secondsInMinute;
	}

	constructor() { }

	public getQuoteEngineCookie(): QuoteEngineCookie {
		const quoteEngineCookieRaw: string = document.cookie
			.split(`;`)
			.map(cookie => cookie.trim())
			.find(entry => entry.includes(this.cookieKey))
			?.split(`=`)[1] ?? ``;

		return quoteEngineCookieRaw ? JSON.parse(quoteEngineCookieRaw) : { };
	}

	public update(values: QuoteEngineCookie): void {
		const currentValues: QuoteEngineCookie = this.getQuoteEngineCookie();
		const updatedCookie: QuoteEngineCookie = {
			...this.defaultValues,
			...currentValues,
			...values,
		};
		if (/localhost/.test(location.host)) {
			document.cookie = `${this.cookieKey}=${JSON.stringify(updatedCookie)};samesite=lax;max-age=${this.maxAge}`;
		} else {
			// eslint-disable-next-line max-len
			document.cookie = `${this.cookieKey}=${JSON.stringify(updatedCookie)};samesite=lax;max-age=${this.maxAge};domain=${this.domain}`;
		}
	}

	public clear(): void {
		document.cookie = /localhost/.test(location.host)
			? `${this.cookieKey}=${JSON.stringify({ })}`
			: `${this.cookieKey}=${JSON.stringify({ })};domain=${this.domain}`;
	}
}
